export const ASSIGN_USER_TAG_REQUEST = "ASSIGN_USER_TAG_REQUEST";
export const REMOVE_USER_TAG_REQUEST = "REMOVE_USER_TAG_REQUEST";
export const USER_TAG_RESPONSE = "USER_TAG_RESPONSE";
